<template>
  <div v-if="isEditing">
    <FormSelectDropdown
      :model-value="modelValue?.prompt"
      @update:model-value="updateModelValue({...modelValue, prompt: $event})"
      label="Select a Prompt"
      :options="questions"
      placeholder="Select a prompt"
      class="mb-4"
    />
    <FormTextarea
      :model-value="modelValue?.answer"
      @update:model-value="updateModelValue({...modelValue, answer: $event})"
      :label="modelValue?.prompt || 'Select a Prompt'"
      placeholder="Write a short answer to the prompt here"/>
    <FormButton color="green" @click="setIsEditing(false)">
      Done
    </FormButton>
  </div>
  <div v-else-if="hasModelValue"
       :class="editable && 'cursor-pointer hover:underline'"
       @click="setIsEditing(true)"
       class="text-sm group/candidate-item">
    <p v-if="modelValue?.prompt" class="mb-2 font-bold text-slate-700">
      {{ modelValue.prompt }}
      <PencilSquareIcon v-if="editable"
                        class="inline-block h-4 w-4 text-slate-600 opacity-50 group-hover/candidate-item:opacity-100 transition-all ml-1.5"/>
    </p>
    <p v-if="modelValue?.answer">{{ modelValue.answer }}</p>
    <p v-else class="text-slate-400">No answer yet</p>
  </div>
  <FormButton v-else-if="editable" color="gradient" @click="setIsEditing(true)" flex
              class="-mt-2 mb-2 block">
    <PlusCircleIcon class="mr-1 h-4 w-4"/>
    <span>Add {{fieldName}}</span>
  </FormButton>
</template>

<script setup>
import FormButton from "./FormButton.vue";
import FormSelectDropdown from "./FormSelectDropdown.vue";
import FormTextarea from "./FormTextarea.vue";
import {PencilSquareIcon, PlusCircleIcon} from "@heroicons/vue/24/solid/index.js";
import {computed, ref} from "vue";

const emits = defineEmits(["update:modelValue"]);
const props = defineProps({
  editable: Boolean,
  fieldName: String,
  modelValue: Object,
  questions: Array,
});

const isEditing = ref(false);

const setIsEditing = (value) => {
  if (!props.editable) return;
  isEditing.value = value;
};

const updateModelValue = (value) => {
  if (!props.editable) return;
  emits("update:modelValue", value);
};

const hasModelValue = computed(() => {
  return props.modelValue?.prompt || props.modelValue?.answer;
});
</script>
